import { ChatAlt2Icon, MailIcon, PhoneIcon } from "@heroicons/react/outline";
import Body from "components/Body";
import Button from "components/Button";
import NextLink from "components/NextLink";
import BottomRightSmallShape from "components/Shapes/BottomRightSmallShape";
import TopLeftSmallShape from "components/Shapes/TopLeftSmallShape";
import useTranslation from "next-translate/useTranslation";
import React from "react";

export default function ContactCTABlock({ data }) {
  const { lang } = useTranslation();

  return (
    <div className="mx-auto lg:max-w-screen-lg">
      <div className="relative bg-primary p-16 rounded-lg text-white text-center">
        <div className="absolute top-0 left-0" aria-hidden="true">
          <TopLeftSmallShape className="w-36 h-auto text-white" />
        </div>
        <div className="absolute bottom-0 right-0" aria-hidden="true">
          <BottomRightSmallShape className="w-36 h-auto text-white" />
        </div>

        <div
          className="absolute top-0 left-1/2 p-4 bg-primary-dark rounded-md -translate-x-1/2 -translate-y-1/2"
          aria-hidden="true"
        >
          <ChatAlt2Icon className="w-8 h-8" />
        </div>

        <h2 className="text-2xl font-important">{data.info}</h2>

        {data.body?.processed && (
          <div className="prose max-w-none text-white">
            <Body value={data.body.processed} />
          </div>
        )}

        <ul className="flex flex-col lg:flex-row items-center justify-center gap-8 mt-12">
          {data.field_links.map((link) => {
            const [type, value] = link.uri.split(":");
            const hasType = typeof value !== "undefined";

            return (
              <li key={link.id}>
                {hasType && (type === "tel" || type === "mailto") ? (
                  <Button as="a" theme="primary-dark" href={link.url} inverse>
                    <span className="flex items-center gap-2">
                      {type === "tel" && (
                        <PhoneIcon className="h-5 w-5 text-primary group-hover:text-white transition-colors" />
                      )}
                      {type === "mailto" && (
                        <MailIcon className="h-5 w-5 text-primary group-hover:text-white transition-colors" />
                      )}
                      <span className="font-important font-medium">
                        {link.title}
                      </span>
                    </span>
                  </Button>
                ) : (
                  <Button
                    as={NextLink}
                    theme="primary-dark"
                    href={link.url}
                    inverse
                  >
                    <span className="flex items-center gap-2">
                      {hasType && type === "entity" && value === "node/291" && (
                        <MailIcon className="h-5 w-5 text-primary group-hover:text-white transition-colors" />
                      )}
                      <span className="font-important font-medium">
                        {link.title}
                      </span>
                    </span>
                  </Button>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
